import {IServiceContent} from "@/model/Content/ServiceContent"
import TransportServiceContent from "@/model/Content/TransportServiceContent"

export interface IHasServiceContent {
    getServiceContent(): IServiceContent | null | TransportServiceContent
    setServiceContent(content: IServiceContent): void
}

function hasServiceContent<TBase extends Constructor>(Base: TBase) {
    return class extends Base implements IHasServiceContent {
        private content: IServiceContent | null = null

        constructor(...args: any[]) {
            super(...args);
        }

        public getServiceContent(): IServiceContent | null | TransportServiceContent {
            return this.content
        }
        public setServiceContent(content: IServiceContent): void {
            this.content = content
        }
    };
}

export default hasServiceContent